import { cn } from '@/lib/utils';

type SettlementRowTone = 'muted' | 'strong' | 'total';

const toneClasses: Record<SettlementRowTone, { label: string; value: string }> =
  {
    muted: {
      label: 'text-sm text-neutral-500',
      value: 'text-[15px] tabular-nums text-neutral-500',
    },
    strong: {
      label: 'text-sm text-neutral-500',
      value: 'text-[15px] font-semibold tabular-nums text-ink',
    },
    total: {
      label: 'text-[15px] font-bold text-ink',
      value: 'text-2xl font-extrabold tabular-nums text-ink',
    },
  };

interface ParticipantTotalsRowProps
  extends React.HTMLAttributes<HTMLDivElement> {
  label: React.ReactNode;
  value: React.ReactNode;
  tone?: SettlementRowTone;
}

/**
 * Wiersz stopki rozliczenia — podpis po lewej, kwota po prawej. Wyrównanie do
 * linii pisma trzyma podpis na miejscu, choć kwoty mają różne stopnie pisma.
 */
const ParticipantTotalsRow = ({
  label,
  value,
  tone = 'muted',
  className,
  ...props
}: ParticipantTotalsRowProps) => (
  <div
    className={cn('flex items-baseline justify-between gap-5', className)}
    {...props}
  >
    <span className={toneClasses[tone].label}>{label}</span>
    <span className={cn('whitespace-nowrap', toneClasses[tone].value)}>
      {value}
    </span>
  </div>
);

export default ParticipantTotalsRow;
